import React from 'react';
import TextField from '@material-ui/core/TextField';
import IntlMessages from 'util/IntlMessages';
function Ort(props) {
    const [value, setValue]=React.useState(props.Ort)
    const onChangeHandle=(e)=>{
        setValue(e.target.value)
    }
    const onBlurHandle=(e)=>{
        props.onChangeKund("Ort",value)
    }
    return (
        <div>
           <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="title"
           label={<IntlMessages id="input.City"/>}
           value={value}
           onChange={onChangeHandle}
           onBlur={onBlurHandle}
           InputLabelProps={{ shrink: true }}
           /> 
        </div>
    );
}

export default Ort;